import { useEffect, useState } from "react";
import BarGraph from "../svg-graphs/BarGraph";
import { getPeakHours } from "../../utils/dataFetch";

export default function PeakHours({ startDate, endDate }) {
    const [error, setError] = useState("");
    const [peakHours, setPeakHours] = useState([]);

    useEffect(() => {
        const fetchPeakHours = async () => {
            try {
                const tempStart = new Date(startDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const result = await getPeakHours(tempStart.toISOString(), tempEnd.toISOString());
                setPeakHours(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchPeakHours();
    }, [startDate, endDate]);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Пікові години</h5>
                {error && <div className="alert alert-danger m-auto rounded-5">{error}</div>}
                {!error && (
                    <>
                        <div className="mt-3">
                            <BarGraph inputData={peakHours} legendLabels={["Кількість відвідувачів"]} rowLabel={"Час"} pixelWidth={1500} pixelHeight={1000} />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
